import GuarantyCompareFormComponent from "../../components/guaranty/GuarantyCompareFormComponent";
import { IGarantie, IOffersDetails} from "../../context/model";
import { isMobile } from "../../utils/utils";

type GuarantyCompareBlocProps = {
  handleSwitchPage: () => void;
  garanties: IGarantie[]
  options: Record<string, IOffersDetails | null>    
}

export default function GuarantyCompareBloc({handleSwitchPage, garanties, options} : Readonly<GuarantyCompareBlocProps>) {

      return (
        <div className="">
          <div className={isMobile() ? "p-lg" : ""}>
            <h2 className="card-title bleu">Comparez les formules</h2>
            <p className="text m-y-sm ta-justify ta-center">
              Découvrez et comparez à travers nos exemples illustratifs vos prises en charge. 
            </p>
            
            <GuarantyCompareFormComponent handleSwitchPage={handleSwitchPage} garanties={garanties} options={options}/>
          </div>
        </div>
      )
}